<div class="upload-wrapper" [ngClass]="{
    dragover: isDraggingFile,
    loading: isLoadingFile,
    loadingError: isLoadingFileError,
    isTouchOnlyPlatform: browsersniffer.isTouchDevice && browsersniffer.isMobileOS
  }">
  <!-- loading -->
  @if(isLoadingFile&&!isLoadingFileError){
    <div class="upload-content">
      <span class="icon-wrapper mb-1">
        <mat-spinner class="tertiary-spinner" [diameter]="25"></mat-spinner>
      </span>
      {{ loadingText | translate}}
    </div>
  }
  <!-- error  -->
  @if(isLoadingFileError){
    <div class="upload-content">
      <span class="icon-wrapper ">
        <mat-icon class="uploader-icon">sentiment_dissatisfied</mat-icon>
      </span>
      {{ loadingFailedText | translate : { supportedExtensions: formatList(allowedExtensions), max:
      getMaxUploadSizePerFile()} }}
      <button (click)="back()" mat-button class="back-tip"><mat-icon aria-label="map">arrow_back_ios</mat-icon>{{"general.back"|translate}}</button>
    </div>
  }
  <!-- start -->
  @if(!isLoadingFile&&!isLoadingFileError){
    <div>
      @if (!browsersniffer.isTouchDevice && !browsersniffer.isMobileOS) {
        <mat-icon class="uploader-icon">file_upload</mat-icon>
        <br>
          {{ extraInfoWithDropFunctionText | translate }}
          <br>
          }


          <div class="flex-container container-centered">
            <label class="upload-button file-upload-button">
              <div class="upload-button-flex-container">

                <input #inputSelectFileElement (change)="onSelectImport()" type="file" name="fill-in"
                  [attr.multiple]="multiple ? multiple : null" 
                  [attr.accept]="accept ? accept : null"
                  [disabled]="isLoadingFile" />
                @if ((browsersniffer.isTouchDevice && browsersniffer.isMobileOS)) {
                  <mat-icon class="uploader-icon">
                    drive_folder_upload
                  </mat-icon>
                }
                <span>
                  {{ fileButtonText | translate }}
                </span>
              </div>
            </label>
          </div>
        </div>
      }
      @if(showFileList && getUploaderFiles().length > 0){
        <mat-list>
          <div mat-subheader>{{ "file-uploader.imported-files" | translate }}</div>
          @for (file of getUploaderFiles(); track file) {
            <mat-list-item [ngClass]="{'file-contains-errors': file.errors && file.errors.length > 0}">
              <mat-icon mat-list-icon>image</mat-icon>
              <div mat-line>{{ file.file.name }}</div>
              @for (error of file.errors; track error) {
                <div mat-line>
                  <mat-error class="error-line">
                    <mat-icon style="color: red;">error</mat-icon> {{ error | translate : { supportedExtensions:
                    formatList(allowedExtensions), max: getMaxUploadSizePerFile()} }}
                  </mat-error>
                </div>
              }
              <div class="remove-file-btn" (click)="removeFromImportedFiles(file)">
                <mat-icon>close</mat-icon>
              </div>
            </mat-list-item>
          }

          <mat-action-list>
            <mat-list-item (click)="clearFileList()" class="action-list-item">Clear</mat-list-item>
          </mat-action-list>
        </mat-list>
      }
</div>